<template>
  <div>
    <vs-popup class="user-edit-popup" id="popup" :title="`Number Sequence - ${sequenceName}`" @close="open = false"
      :active.sync="open" :buttons-hidden="true"> 
      <div class="mb-2 vx-row">
        <div class="w-full vx-col md:w-1/2 md:mb-0 mt-5">
          <vs-button v-if="is_editable" @click="addCard" icon-pack="feather" icon="icon-plus" class="shadow-sm ml-6"
            color="primary" size="medium">
            Add New Section
          </vs-button>
        </div>
        <div class="w-full vx-col md:w-1/2 md:mb-0">
          <small class="label">Example preview</small>
          <vs-input size="large" readonly class="w-full" name="length" type="text" v-model="preview" />
        </div>
      </div>
      <vs-row vs-w="12">
        <vs-col v-for="(content, index) in sequence" :key="index + 'content'" vs-type="flex" vs-justify="center"
          vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" class="px-4 pb-4">
          <vx-card-custom titleColor="#736F6E" class="my-8" :subtitle="index + 1 + ''"
            :remove-card-action="(sequence.length > 1) && is_editable" v-on:remove="removeCard(index)">
            <div class="vx-row mb-3 mt-4">
              <div class="vx-col w-1/2 md:mb-0">
                <small class="label">Type <span class="text-danger">*</span></small>
                <v-select :disabled="!is_editable" label="key" :closeOnSelect="true" :options="typeList"
                  v-model="sequence[index].type" @input="onInputType(index)" :reduce="option => option.value" />
                <small v-if="!sequence[index].type" class="text-danger">This field is required</small>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <small class="label">Separator</small>
                <vs-input :disabled="!is_editable" class="w-full" name="separator" type="text"
                  v-model="sequence[index].separator" />
              </div>
            </div>
            <div class="vx-row mb-3 mt-4">
              <div class="vx-col md:w-full w-full md:mb-0" v-if="sequence[index].type === 'drop_down'">
                <div class="vx-row">
                  <div class="vx-col w-2/5">
                    <small class="label">{{ sequenceName === 'Formulation Code ID' ? 'Add your FG code prefix here' : 'Options' }}</small>
                  </div>
                  <div class="vx-col w-3/5 flex" v-if="sequenceName === 'Formulation Code ID'">
                    <small class="label mt-1">Select FG product category</small>
                    <vx-tooltip
                      class="ml-4"
                      position="top"
                      title="Dilution & Development codes have a specific function m-Hub and can only be used once"
                      color="primary"
                      text="Dilution formulae are WIP and as such will not be broken down into component RMs in the WO. Development codes are used as a baseline for all production codes. Note, you can have multiple Production codes.">
                      <vs-button color="warning" type="border" icon-pack="feather" icon="icon-help-circle" size="small"></vs-button>
                    </vx-tooltip>
                  </div>
                </div>
                <span v-for="(option_value, value_index) in sequence[index].values" :key="value_index">
                  <div class="vx-row">
                    <div class="vx-col w-2/5">
                      <vs-input @input="onInputDropdown()" :disabled="!is_editable && !sequence[index].values[value_index].editable" class="w-full mt-2"
                        :name="`values_${value_index}`" type="text"
                        v-model="sequence[index].values[value_index].value" />
                      <small v-if="!sequence[index].values[value_index].value" class="text-danger">This field is
                        required</small>
                    </div>
                    <div class="vx-col w-2/5" v-if="sequenceName === 'Formulation Code ID'">
                      <vs-input v-model="sequence[index].values[value_index].category" class="w-full mt-2" readonly/>
                      <!-- <v-select disabled label="key" :closeOnSelect="true"
                        :reduce="option => option.value"
                        :options="[{ key: 'Production', value: 'Product' }]"
                        v-model="sequence[index].values[value_index].category" @input="onInputDropdown()"
                        class="mt-2" />
                      <small v-if="!sequence[index].values[value_index].category" class="text-danger">This field is
                        required</small> -->
                    </div>
                    <div class="vx-col w-1/5">
                      <vs-button v-if="is_editable && (sequenceName !== 'Formulation Code ID' || sequence[index].values[value_index].category === 'Product')" class="mt-2"
                        @click.stop="onClickRemoveValueFromDropdown(index, value_index)" type="filled"
                        icon-pack="feather" icon="icon-trash-2" color="danger"
                        :disabled="sequence[index].values.length < 2"></vs-button>
                    </div>
                  </div>
                </span>
                <div class="text-danger mt-2"> {{ checkDuplicateErrors(sequence[index].values) }}</div>
                <vs-button class="mt-2"
                  @click.stop="onClickAddValueToDropdown(index)">add</vs-button>
              </div>
              <template v-if="!(sequence[index].type === 'raw material' || sequence[index].type === 'formulation')">
                <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="sequence[index].type === 'string'">
                  <small class="label">Value <span class="text-danger">*</span></small>
                  <vs-input :disabled="!is_editable" class="w-full" name="value" type="text"
                    v-model="sequence[index].value" />
                  <small v-if="!sequence[index].value" class="text-danger">This field is required</small>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="sequence[index].type === 'number'">
                  <small class="label">How many numbers/digits <span class="text-danger">*</span> </small>
                  <vs-input :disabled="!is_editable" class="w-full" name="length" type="text"
                    v-model="sequence[index].length" />
                  <small v-if="!sequence[index].length" class="text-danger">This field is required</small>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="sequence[index].type === 'number'">
                  <small class="label">Prefix Value</small>
                  <vs-input :disabled="!is_editable" class="w-full" name="prefix_value" type="text"
                    v-model="sequence[index].prefix_value" />
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="sequence[index].type === 'number'">
                  <small class="label">Starting Number</small>
                  <vs-input :disabled="!is_editable" class="w-full" name="starting_number" type="text"
                    v-model="sequence[index].starting_number"/>
                    <small v-if="sequence[index].starting_number_error" class="text-danger">
                      {{ sequence[index].starting_number_error }}
                    </small>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="sequence[index].type === 'date'">
                  <small class="label">Format <span class="text-danger">*</span></small>
                  <v-select :disabled="!is_editable" label="key" :closeOnSelect="true" :options="dateFormats"
                    v-model="sequence[index].format" :reduce="option => option.value" />
                  <small v-if="!sequence[index].format" class="text-danger">This field is required</small>
                </div>
              </template>
            </div>
          </vx-card-custom>
        </vs-col>
      </vs-row>
      <div v-if="is_editable || ['Raw Material Code ID', 'Formulation Code ID', 'Sundry Item ID Number'].includes(sequenceName)" class="flex flex-wrap items-center justify-end mt-8">
        <vs-button @click="submitChanges" class="ml-auto mt-2" :disabled="errors">Save Changes</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import vSelect from 'vue-select'
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";
import moment from "moment";

const TenantSettingRepository = RepositoryFactory.get('settings')
export default {
  name: "SequenceUpdatePopUp",
  data() {
    return {
      open: false,
      sequenceId: null,
      sequenceName: '',
      sequence: [],
      dateFormats: [
        { key: 'd/m/Y (ex: 31/08/2022)', value: 'd/m/Y', preview: '31/08/2022' },
        { key: 'm/d/Y (ex: 08/31/2022)', value: 'm/d/Y', preview: '08/31/2022' },
        { key: 'd/m/y (ex: 31/08/22)', value: 'd/m/y', preview: '31/08/22' },
        { key: 'm/d/y (ex: 08/31/22)', value: 'm/d/y', preview: '08/31/22' },
        { key: 'Y-m-d (ex: 2022-08-31)', value: 'Y-m-d', preview: '2022-08-31' },
        { key: 'd-m-Y (ex: 31-08-2022)', value: 'd-m-Y', preview: '31-08-2022' },
        { key: 'm-d-Y (ex: 08-31-2022)', value: 'm-d-Y', preview: '08-31-2022' },
        { key: 'd-m-y (ex: 31-08-22)', value: 'd-m-y', preview: '31-08-22' },
        { key: 'm-d-y (ex: 08-31-22)', value: 'm-d-y', preview: '08-31-22' },
      ],
      typeList: null,
      formattedPayload: [],
      seqName: '',
      preview: '',
      is_editable: false,
      errors:false,
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    'v-select': vSelect,
  },
  methods: {
    openPopUp(sequenceId, sequenceName) {
      this.typeList = [
        { key: 'Static Text', value: 'string' },
        { key: 'Number', value: 'number' },
        { key: 'Date', value: 'date' }
      ]
      this.open = true
      this.tenantId = this.$route.params.id
      this.sequenceId = sequenceId
      this.sequenceName = sequenceName
      this.loadSequence()
    },
    async loadSequence() {
      this.$vs.loading()
      const { data } = await TenantSettingRepository.getTenantSequence(this.tenantId, this.sequenceId)
      this.sequence = data.data
      this.is_editable = data.is_editable
      if(['Raw Material Code ID', 'Formulation Code ID', 'Sundry Item ID Number'].includes(data.name)) {
        this.typeList.push({ key: 'Pick List', value: 'drop_down' })
      }
      this.sequence = this.sequence.map((x) => {
        if (x.type === 'drop_down' && data.name) {
          x.values = x.values.map((y) => {
            return { value: y, category: x.category[y] ? x.category[y] : null }
          })
        }
        return x
      })
      this.$vs.loading.close()
      this.generatePreview()
    },
    async submitChanges() {
      this.$vs.loading()
      const vue = this
      this.sequence.forEach((content, index) => {
        this.sequence[index].order = index + 1
      })
      this.formattedPayload = this.sequence.map((content) => {
        if (content.type === 'string') {
          return {
            type: content.type,
            order: content.order,
            value: content.value,
            separator: content.separator
          }
        }
        if (content.type === 'date') {
          return {
            type: content.type,
            order: content.order,
            format: content.format,
            separator: content.separator
          }
        }
        if (content.type === 'number') {
          return {
            type: content.type,
            order: content.order,
            length: content.length,
            separator: content.separator,
            prefix_value: content.prefix_value,
            starting_number: content.starting_number,
          }
        }
        if (content.type === 'raw material' || content.type === 'raw_material') {
          return {
            order: content.order,
            type: 'raw_material',
            separator: content.separator
          }
        }
        if (content.type === 'formulation') {
          return {
            order: content.order,
            type: 'formulation',
            separator: content.separator
          }
        }
        if (content.type === 'drop_down') {
          let formatted_values = []
          let formatted_category = {}
          console.log(content.values);
          if (this.sequenceName !== 'Formulation Code ID') {
            formatted_values = content.values.map((x) => x.value)
          }
          if (this.sequenceName === 'Formulation Code ID') {
            formatted_values = content.values.map((x) => x.value)
            formatted_category = content.values.reduce((result, item) => {
              result[item.value] = item.category;
              return result;
            }, {});
          }
          return {
            order: content.order,
            type: content.type,
            separator: content.separator,
            values: formatted_values,
            category: formatted_category
          }
        }
      })

      const payload = {
        data: this.formattedPayload
      }
      console.log(payload);
      try {
        const { data } = await TenantSettingRepository.updateTenantSequence(this.tenantId, this.sequenceId, payload)
        await vue.$parent.refreshData()
        this.open = false
        this.showSuccessMessage('Sequence Updated Successfully')
      } catch (error) {
        this.$vs.loading.close()
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    addCard() {
      const newObject = {
        separator: '',
        type: 'string',
        value: ''
      }
      this.sequence.push(newObject)
    },
    removeCard(cardIndex) {
      this.sequence.splice(cardIndex, 1)
    },
    generatePreview() {
      this.preview = ''
      this.sequence.forEach((content, index) => {
        const separator = content.separator && (this.sequence.length - 1 !== index) ? content.separator : ''
        if (content.type === 'string') {
          this.preview = `${this.preview}${content.value}${separator}`
        }
        if (content.type === 'raw material' || content.type === 'raw_material') {
          this.preview = `${this.preview}OIL${separator}`
        }
        if (content.type === 'formulation') {
          this.preview = `${this.preview}NATSD${separator}`
        }
        if (content.type === 'number') {
          const prefix = content.prefix_value || '';
          const startingNum = content.starting_number || '';
          
          const missingNumberCount = content.length - (prefix.length + startingNum.length);
          const zeroString = '0'.repeat(Math.max(missingNumberCount, 0));
          
          const num = `${prefix}${zeroString}${startingNum}`;
          this.preview = `${this.preview}${num}${separator}`;
        }
        if (content.type === 'date') {
          const dateFormatObj = this.dateFormats.find(obj => obj.value === content.format)
          this.preview = `${this.preview}${dateFormatObj && dateFormatObj.preview ? dateFormatObj.preview : ''}${separator}`
        }
        if (content.type === 'drop_down') {
          this.preview = `${this.preview}${content.values.length && content.values[0].value ? content.values[0].value : '<pick_list_value>'}${separator}`
        }
      })
    },
    async generateZeroString(number) {
      for (let i = 10; i < 10; i++) {
        console.log("numbering")
      }
    },
    onClickAddValueToDropdown(seq_index) {
      this.open = false
      this.open = true
      this.sequence[seq_index].values.push({ value: '', category: this.sequenceName === 'Formulation Code ID' ? 'Product' : null, editable: true })
    },
    onClickRemoveValueFromDropdown(seq_index, value_index) {
      this.open = false
      this.open = true
      this.sequence[seq_index].values.splice(value_index, 1)
    },
    onInputDropdown() {
      this.open = false
      this.open = true
    },
    onInputType(index) {
      if (this.sequence[index].type === 'drop_down' && this.sequenceName !== 'Formulation Code ID') {
        this.sequence[index].values = [{ value: '', category: null }]
      } else {
        this.sequence[index].values = [
          { value: 'DEV', category: 'Development', editable: false},
          { value: 'DIL', category: 'Dilution', editable: false },
          { value: '', category: 'Product', editable: true }
        ]
      }
    },
    checkDuplicateErrors(values) {
      const valueCount = {};
      const categoryCount = {};
      const duplicateValues = [];
      const duplicateCategories = [];

      for (const item of values) {

        if (valueCount[item.value]) {
          if (!duplicateValues.includes(item.value)) {
            duplicateValues.push(item.value);
          }
        } else {
          valueCount[item.value] = true;
        }

        if (item.category !== null) {
          if (categoryCount[item.category]) {
            if (!duplicateCategories.includes(item.category)) {
              duplicateCategories.push(item.category === 'Product' ? 'Production' : item.category);
            }
          } else {
            categoryCount[item.category] = true;
          }
        }
      }

      const errors = [];
      if (duplicateValues.length > 0) {
        errors.push(`Duplicate value(s): ${duplicateValues.join(', ')}`);
      }
      // if (duplicateCategories.length > 0) {
      //   errors.push(`Duplicate category(ies): ${duplicateCategories.join(', ')}`);
      // }

      return errors.length > 0 ? `Error: ${errors.join(' | ')}` : null;
    },
    checkIfTextExists() {
      const formDiv = document.querySelector('.user-edit-popup');
      console.log(formDiv.textContent, 'sasa')
      if (formDiv && formDiv.textContent.includes('This field is')) {
        return true;
      }
      return false;
    }
  },
  watch: {
    sequence: {
      handler(newSequence) {
        this.generatePreview()
        newSequence.forEach((item, index) => {
        if (item.type === 'number' && item.starting_number && item.length) {
          const numLength = item.starting_number.toString().length;
          if (numLength > parseInt(item.length)) {
            this.errors = true
            this.$set(this.sequence[index], 'starting_number_error', 'Starting number must match the specified length.');
          } else {
            this.errors = false
            this.$set(this.sequence[index], 'starting_number_error', '');
          }
        }
      });
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.user-edit-popup>>>.vs-popup {
  width: 50%;
}
</style>
